import React, { Component } from 'react';
import './App.css';
import 'milligram/dist/milligram.css'
import FirstPage from './component/FirstPage';
import SecondPage from './component/SecondPage';

class App extends Component {
  render() {
    return (
      <div className="App">
        <FirstPage />
        <SecondPage />
      </div>
    );
  }
}

export default App;
